// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorSearchModelResponse {
    static getAttributeTypeMap() {
        return PayorSearchModelResponse.attributeTypeMap;
    }
}
PayorSearchModelResponse.discriminator = undefined;
PayorSearchModelResponse.additionalProperties = false;
PayorSearchModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PayorSearchResponseModel"
    },
];
//# sourceMappingURL=payorSearchModelResponse.js.map